export default __webpack_public_path__ + "static/media/menu.1d3072ae.jpg";